// extracted by mini-css-extract-plugin
export var emptyState = "_5m-d";
export var statCard = "_5m-c";
export var table = "_5m-0";
export var tableCell = "_5m-4";
export var tableCellClickable = "_5m-5 _5m-4";
export var tableCellDefault = "_5m-6 _5m-4";
export var tableCellEmpty = "_5m-8";
export var tableCellWithValue = "_5m-7";
export var tableContainer = "_5m-e";
export var tableHeaderWeight = "_5m-1";
export var tableHeaderZone = "_5m-2";
export var tableRowHeader = "_5m-3";
export var viewModeButton = "_5m-9";
export var viewModeButtonActive = "_5m-a _5m-9";
export var viewModeButtonInactive = "_5m-b _5m-9";